import React from "react";
import { Container, Row, Col, Input } from "reactstrap";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {
  Typography,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  AppBar,
} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import List from "@material-ui/core/List";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import Popover from "@material-ui/core/Popover";
import ForumIcon from "@material-ui/icons/Forum";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import DirectionsIcon from "@material-ui/icons/Directions";
import { VisibilityRounded } from "@material-ui/icons";
import PeopleIcon from "@material-ui/icons/People";
import GroupIcon from "@material-ui/icons/Group";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ForumTwoToneIcon from "@material-ui/icons/ForumTwoTone";
import { ChatBox } from "../../../../../utils/ChatBox";
import { isTheSameMinute } from "../../../../../../helpers/time.helper";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import { labelHelper } from "../../../../../../helpers/labelHelper";

const OnlineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    borderBottom: "1px solid gainsboro",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  online: {
    background: "#44b700",
  },
  offline: {
    background: "orangered",
  },
}));
export default class ChatWindow extends React.Component {
  state = {
    text: "",
    autoScrollLocked: false,
    hiddenMessages: 0,
    initalScrollPos: null,
  };
  componentDidMount() {
    this.scrollRef = React.createRef();
    document.addEventListener("keyup", this.onEnter);
    this.handleScroll();
  }

  onEnter = (e) => {
    var e = e || window.event; // for IE to cover IEs window event-object
    if (e.which == 13 && this.state.text) {
      this.sendMessage();
    }
  };
  clearChat = () => {
    this.setState({ messages: [] });
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.scroll && !prevProps.scroll) {
      if (!this.state.autoScrollLocked) {
        this.handleScroll();
      }
    }
    if (this.props.currentChat != prevProps.currentChat) {
      if (!this.state.autoScrollLocked) {
        this.handleScroll();
      }
    }
  }

  handleScroll = (id) => {
    const { currentChat, chats } = this.props;
    if (currentChat && currentChat.target) {
      let chatIndex = chats.indexOf(
        chats.find((c) => c.target == currentChat.target)
      );
      if (chatIndex > -1) {
        let index = chats[chatIndex].messages.length - 1;
        if (index > -1 && this.refs[index] !== undefined) {
          try {
            this.refs[index].scrollIntoView({
              block: "end",
              behavior: "smooth",
            });

            this.setState({ loaded: false, autoScrollLocked: false });

            /*       setTimeout(() => {
      
                                  let initalScrollPos = this.scrollRef.current.scrollTop;
                                  this.setState({ initalScrollPos })
                              }, 1500) */
          } catch (error) {
            console.error(error);
          }
        }
      }
    }
  };

  sendMessage = () => {
    const { text } = this.state;
    const { currentChat } = this.props;
    let target = currentChat.target;
    let room = `ALL`;

    if (currentChat && currentChat.target == `ALL`) target = null;

    let isValid = text && text.length <= 500;

    if (isValid) {
      this.props.sendMessage(text);
      this.setState({ text: "" });
    }
  };
  onScroll = (manual = false) => {
    if (manual && this.scrollRef && this.scrollRef.current) {
      const { initalScrollPos, hiddenMessages, autoScrollLocked } = this.props;
      const scrollTop = this.scrollRef.current.scrollTop;
      if (initalScrollPos >= 150 && scrollTop <= initalScrollPos - 150) {
        this.setState({ autoScrollLocked: true });
      }

      if (
        initalScrollPos + hiddenMessages * 82 <= scrollTop &&
        autoScrollLocked
      ) {
        const { chats, currentChat } = this.state;
        let cc = chats.find((c) => c.target == currentChat.target);
        const updatedChat = chats;
        if (cc && !cc.seen) {
          let index = updatedChat.indexOf(cc);
          if (index > -1) updatedChat[index].seen = true;
          cc.seen = true;
          if (cc.target != "ALL") {
            this.setMessageSeen(cc.target);
          }
        }
        this.setState({ autoScrollLocked: false, hiddenMessages: 0 });
      }
    }
  };
  scrollToBottom = () => {
    const { chats, currentChat } = this.props;
    let cc = chats.find((c) => c.target == currentChat.target);
    if (cc && !cc.seen) {
      const updatedChat = chats;
      let index = updatedChat.indexOf(cc);
      if (index > -1) updatedChat[index].seen = true;
      cc.seen = true;
      this.setState({ chats: updatedChat, currentChat: cc });
      if (cc.target != "ALL") {
        this.setMessageSeen(cc.target);
      }
    }
    this.setState({ autoScrollLocked: false, hiddenMessages: 0 });
    this.handleScroll();
  };
  renderTargetCard = () => {
    const { currentChat, orderList } = this.props;
    const { connectionList } = this.props;
    const { target } = currentChat;
    const { eventId } = this.props;
    const person = orderList.find((o) => o.badgeNo == target);
    if (!person && target == `ALL`) {
      return (
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar
              className="chat-avatar"
              style={{ backgroundColor: "rgb(90, 96, 227)" }}
            >
              <GroupIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography
                component="h4"
                /*       variant="body2" */
                className="primary-text"
                color="textPrimary"
              >
                <SystemLabel name="OpenChat" />
              </Typography>
            }
            secondary={
              <Typography
                component="h4"
                /*    variant="body2" */
                className="secondary-text"
                color="textPrimary"
              >
                {connectionList.length} {"  "} <SystemLabel name="Attendees" />
              </Typography>
            }
          />
        </ListItem>
      );
    }
    if (!person && target == `MODERATOR`) {
      return (
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar
              className="chat-avatar"
              style={{ backgroundColor: "rgb(90, 96, 227)" }}
            >
              <VerifiedUserIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography
                component="h4"
                /*       variant="body2" */
                color="textPrimary"
              >
                <SystemLabel name="Moderator" />
              </Typography>
            }
            secondary={
              <Typography component="h4" variant="body2" color="textPrimary">
                <SystemLabel name="AskYourQuestions" />
              </Typography>
            }
          />
        </ListItem>
      );
    }
    if (!person)
      return (
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <StatusBadge
              online={
                connectionList.find((c) => c.clientKey == target) || false
              } /* name={person.initials} */
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography
                component="h4"
                /*          variant="body2" */
                className="primary-text"
                color="textPrimary"
              >
                <SystemLabel name="AnonymousClient" />
                {"_"}
                {target ? target.substring(0, 8) : ""}
              </Typography>
            }
          />
        </ListItem>
      );
    return (
      <ListItem alignItems="flex-start">
        <ListItemAvatar>
          <StatusBadge
            online={
              connectionList.find((c) => c.clientKey == target) || false
            } /* name={person.initials} */
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Typography
              component="h4"
              /*     variant="body2" */
              className="primary-text"
              color="textPrimary"
            >
              {person.name}
            </Typography>
          }
          secondary={
            <Typography className="secondary-text">{person.company}</Typography>
          }
        />
      </ListItem>
    );
  };
  render() {
    const { extraProps } = this.props;
    const { currentChat, chats } = this.props;
    const { clientKey, template, connectionList, orderList } = this.props;
    return (
      <Card
        className="dark-card"
        style={{ margin: 10, height: "calc(100% - 10px)" }}
      >
        <CardContent
          style={{
            minHeight: "calc(100% - 40px)",
            maxHeight: "calc(100% - 40px)",
          }}
        >
          <div
            className="chat-container"
            style={{ border: 0, background: "transparent" }}
          >
            <AppBar
              position={"static"}
              style={{
                width: "100%",
                background: "#1d1d1d",
                boxShadow: "none",
                borderBottom: "1px solid #2d2c2c",
              }}
            >
              <Row>
                <Col className="col-6 text-left">
                  {currentChat ? this.renderTargetCard() : null}
                </Col>
                <Col
                  className="col-6 text-right"
                  style={{ paddingTop: 10 }}
                ></Col>
              </Row>
            </AppBar>
            {currentChat ? (
              <React.Fragment>
                <div
                  className="conversation jir-scroll dark-list"
                  style={{
                    backgroundColor: "#1d1d1d",
                    width: "100%",
                    height: "calc(100vh - 244px)",
                  }}
                  ref={this.scrollRef}
                  onScroll={() => this.onScroll(true)}
                >
                  {currentChat.target &&
                  chats.find((c) => c.target == currentChat.target)
                    ? chats
                        .find((c) => c.target == currentChat.target)
                        .messages.map((m, i) => {
                          return (
                            <div ref={i} key={i} className="c-box">
                              <ChatBox
                                size={this.state.size}
                                message={m.message}
                                id={m.interactionChatId}
                                timeStamp={
                                  (currentChat.messages[i + 1] != undefined &&
                                    !isTheSameMinute(
                                      currentChat.messages[i + 1].inserted,
                                      m.inserted
                                    )) ||
                                  currentChat.messages[i + 1] == undefined
                                    ? m.inserted
                                    : ""
                                }
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "initial",
                                  lineHeight: "auto",
                                  fontFamily: "Open Sans",
                                  color: "#eee",
                                  receiver: {
                                    backgroundColor: "#e4e6eb",
                                    color: "#050505",
                                  },
                                  sender: {
                                    backgroundColor: "#5a60e3",
                                    color: "#fff",
                                  },
                                }}
                                clientKey={!m.senderFirstName ? m.sender : null}
                                name={
                                  m.target == "MODERATOR"
                                    ? "Moderator"
                                    : m.senderOrderId
                                    ? m.senderFirstName +
                                      " " +
                                      m.senderLastName +
                                      (m.senderCompanyName || "")
                                    : null
                                }
                                last={
                                  (currentChat.messages[i + 1] != undefined &&
                                    currentChat.messages[i + 1].sender !=
                                      m.sender) ||
                                  currentChat.messages[i + 1] == undefined
                                    ? true
                                    : false
                                }
                                first={
                                  (currentChat.messages[i - 1] != undefined &&
                                    currentChat.messages[i - 1].sender !=
                                      m.sender) ||
                                  currentChat.messages[i - 1] == undefined
                                    ? true
                                    : false
                                }
                                likes={m.likes}
                                onLike={() => null}
                                fromYou={m.sender == "MODERATOR"}
                              />
                            </div>
                          );
                        })
                    : null}
                </div>

                <div
                  className="text-bar"
                  style={{ border: 0, borderRadius: 15, background: "none" }}
                >
                  {this.state.autoScrollLocked ? (
                    <ScrollToBottomButton
                      unreadMessages={this.state.hiddenMessages}
                      show={
                        this.state.currentChat.seen == false ||
                        (this.state.missedGroupMessages > 0 &&
                          this.state.currentChat == "ALL")
                      }
                      currentChat={this.state.currentChat}
                      scrollToBottom={this.scrollToBottom}
                    />
                  ) : null}
                  <div className="text-bar__field moderator-input ">
                    <Input
                      placeholder={labelHelper.getLabel("TypeSomething")}
                      type="text"
                      style={{ background: "#2c2d2f" }}
                      value={this.state.text}
                      onChange={(e) => this.setState({ text: e.target.value })}
                    />
                  </div>
                  <div className="text-bar__thumb">
                    <IconButton
                      className="icon-button-dark-s"
                      disabled={!this.state.text}
                      onClick={this.sendMessage}
                    >
                      <SendIcon />
                    </IconButton>
                    <IconButton
                      style={{ color: "#5a60e3" }}
                      onClick={() => this.props.sendMessage("THUMB_UP")}
                    >
                      <ThumbUpIcon />
                    </IconButton>
                  </div>
                </div>
              </React.Fragment>
            ) : null}
          </div>
        </CardContent>
      </Card>
    );
  }
}

function ScrollToBottomButton({
  unreadMessages = 0,
  scrollToBottom = () => null,
  show,
}) {
  return (
    <div>
      <div className="scroll-to-bottom-wrapper">
        <Row>
          <div
            className="undread-messages-pillow smooth-shadow"
            onClick={scrollToBottom}
            style={{
              cursor: "pointer",
              opacity: unreadMessages /* && show */ > 0 ? 1 : 0,
            }}
          >
            <span className="exc-badge">{unreadMessages}</span> {"  "}
            <SystemLabel name="UndreadMessages" />
          </div>
        </Row>
        <Row>
          <Col>
            <IconButton onClick={scrollToBottom}>
              <ArrowDownwardIcon />
            </IconButton>
          </Col>
        </Row>
      </div>
    </div>
  );
}

function StatusBadge({ name, online = false }) {
  const classes = useStyles();
  return online ? (
    <OnlineBadge
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      overlap="circle"
      variant="dot"
    >
      <Avatar className="chat-avatar">{/*   {name} */}</Avatar>
    </OnlineBadge>
  ) : (
    <Avatar className="chat-avatar">{/*   {name} */}</Avatar>
  );
}
